import React, { Component, useState, useEffect } from 'react';

import Section from '../MyProfile/Section';

/** @import {OfsProfileData} from './MyAccountTypes' */
/** @import {InterestPaidToProps} from './InterestPaidToTypes' */

const getSelectedFromProps = (/** @type {InterestPaidToProps} */ props) => {
    return props.options.findIndex(x => x.value === props.value);
};

const buildRadioOptions = (/** @type {string} */ productName) => {
  return [
    {
      label: `My ${productName} account`,
      value: 'online_flexi_saver'
    },
    {
      label: `My ${productName} account`,
      value: 'flexi_saver'
    },
    {
      label: `My ${productName} account`,
      value: 'notice_saver'
    },
    {
      label: 'My linked account',
      value: 'linked_account'
    },
  ];
};

/** @extends {Component<InterestPaidToProps>} */
class InterestPaidOptions extends Component {
    static getDerivedStateFromProps(/** @type {InterestPaidToProps} */ props) {       
        return {
            selected: getSelectedFromProps(props)
        };
    }

    isOptionTrue(/** @type {number} */ index) {
        return this.state.selected === index;
    }

    renderOptions() {
        return this.props.options.map((option, i) => (
            <div className="text-input-wrapper" key={i}>
                <input
                    type='TextInput'
                    className="text-input has-value read-only my-interest__input"
                    required={this.isOptionTrue(i)}
                    value={option.label}
                    ref={i === 0 ? this.props.inputRef : null}
                    readOnly
                />
            </div>
        ));
    }

    render() {
        return (
            <div>
                {this.renderOptions()}
            </div>
        );
    }
}


function InterestPaidTo(/** @type {{profile: OfsProfileData}} */  { profile }) {
  const [editing, setEditing] = useState(false);
  const [interestPaidTo, setInterestPaidTo] = useState(profile.interestPaidTo);

  const cancelEditing = () => {
    setInterestPaidTo(profile.interestPaidTo);
  };

  useEffect(() => {
    setInterestPaidTo(profile.interestPaidTo);
  }, [profile.interestPaidTo]);

  return (
      <Section title="Interest paid to" editing={editing} setEditing={setEditing} onCancel={cancelEditing} hideEditing={true}>         
          <InterestPaidOptions
             options={buildRadioOptions(profile.productName)}
             value={interestPaidTo}
          />
    </Section>
  );
};

export default InterestPaidTo;
